if (!customElements.get('cinematic-fashion-banner')) {
  class CinematicFashionBanner extends HTMLElement {
    constructor() {
      super();
      this._navObserver = null;
      this._onResize = null;
      this._sliderActive = false;
      this._slideTimer = null;
      this._slideIndex = 0;
      this._slideTrack = null;
      this._cloneEl = null;
      this._mobileMql = null;
      this._onMobileChange = null;
    }

    connectedCallback() {
      this.scrollContainer = this.querySelector('.cinematic-banner__menu-scroll');
      this.menuWrapper = this.querySelector('.cinematic-banner__menu-wrapper');

      if (this.scrollContainer) {
        this.setupDragScroll();
      }

      this.setupNavigationObserver();
      this.setupMobileSlider();
    }

    disconnectedCallback() {
      if (this._navObserver) {
        this._navObserver.disconnect();
        this._navObserver = null;
      }
      if (this._onResize) {
        window.removeEventListener('resize', this._onResize);
        this._onResize = null;
      }
      if (this._mobileMql && this._onMobileChange) {
        this._mobileMql.removeEventListener('change', this._onMobileChange);
      }
      this.stopMobileSlider();
    }

    setupNavigationObserver() {
      const checkNavigation = () => {
        if (!this.menuWrapper) return;

        if (window.innerWidth <= 749) {
          this.menuWrapper.classList.remove('is-hidden');
          return;
        }

        const headerDetailsOpen = document.querySelectorAll('header details[open]').length > 0;
        const menuDrawerOpen = !!document.querySelector('menu-drawer[open]');
        const hasOpenDropdown = headerDetailsOpen || menuDrawerOpen;

        this.menuWrapper.classList.toggle('is-hidden', hasOpenDropdown);
      };

      this._navObserver = new MutationObserver(checkNavigation);

      document.querySelectorAll('header details').forEach((details) => {
        this._navObserver.observe(details, { attributes: true, attributeFilter: ['open'] });
      });

      const menuDrawer = document.querySelector('menu-drawer');
      if (menuDrawer) {
        this._navObserver.observe(menuDrawer, { attributes: true, attributeFilter: ['open'] });
      }

      this._onResize = checkNavigation;
      window.addEventListener('resize', this._onResize);
      checkNavigation();
    }

    setupDragScroll() {
      let isDown = false;
      let startX = 0;
      let scrollLeft = 0;
      const el = this.scrollContainer;

      el.addEventListener('mousedown', (e) => {
        isDown = true;
        el.style.cursor = 'grabbing';
        startX = e.pageX - el.offsetLeft;
        scrollLeft = el.scrollLeft;
      });

      el.addEventListener('mouseleave', () => {
        isDown = false;
        el.style.cursor = 'grab';
      });

      el.addEventListener('mouseup', () => {
        isDown = false;
        el.style.cursor = 'grab';
      });

      el.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - el.offsetLeft;
        const walk = (x - startX) * 2;
        el.scrollLeft = scrollLeft - walk;
      });
    }

    setupMobileSlider() {
      const slideCount = parseInt(this.dataset.slideCount, 10) || 0;
      if (slideCount < 2) return;

      this._mobileMql = window.matchMedia('(max-width: 749px)');
      this._onMobileChange = () => {
        if (this._mobileMql.matches) this.startMobileSlider();
        else this.stopMobileSlider();
      };
      this._mobileMql.addEventListener('change', this._onMobileChange);
      this._onMobileChange();
    }

    startMobileSlider() {
      if (this._sliderActive) return;
      const track = this.querySelector('.cinematic-banner__images');
      if (!track) return;
      const slideCount = parseInt(this.dataset.slideCount, 10) || 0;
      if (slideCount < 2) return;

      this._hiddenBlanks = Array.from(
        track.querySelectorAll('.cinematic-banner__image-wrapper[data-cb-blank]')
      );
      this._hiddenBlanks.forEach((el) => {
        el.dataset.cbPrevDisplay = el.style.display || '';
        el.style.display = 'none';
      });

      const firstWrapper = track.querySelector(
        '.cinematic-banner__image-wrapper:not([data-cb-blank])'
      );
      if (!firstWrapper) return;
      this._cloneEl = firstWrapper.cloneNode(true);
      this._cloneEl.setAttribute('aria-hidden', 'true');
      this._cloneEl.dataset.cbClone = 'true';
      const clonedImg = this._cloneEl.querySelector('img');
      if (clonedImg) clonedImg.removeAttribute('fetchpriority');
      track.appendChild(this._cloneEl);

      this._slideTrack = track;
      this._slideCount = slideCount;
      this._slideIndex = 0;
      this._sliderActive = true;

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced) return;

      const interval = parseInt(this.dataset.slideInterval, 10) || 4000;
      this._slideTimer = setInterval(() => this.advanceSlide(), interval);
    }

    advanceSlide() {
      if (!this._slideTrack) return;
      this._slideIndex += 1;
      this._slideTrack.classList.remove('cb-no-transition');
      this._slideTrack.style.transform = `translateX(-${this._slideIndex * 100}%)`;

      if (this._slideIndex >= this._slideCount) {
        const onEnd = () => {
          this._slideTrack.removeEventListener('transitionend', onEnd);
          this._slideTrack.classList.add('cb-no-transition');
          this._slideIndex = 0;
          this._slideTrack.style.transform = 'translateX(0)';
          void this._slideTrack.offsetWidth;
          this._slideTrack.classList.remove('cb-no-transition');
        };
        this._slideTrack.addEventListener('transitionend', onEnd);
      }
    }

    stopMobileSlider() {
      if (this._slideTimer) {
        clearInterval(this._slideTimer);
        this._slideTimer = null;
      }
      if (this._cloneEl) {
        this._cloneEl.remove();
        this._cloneEl = null;
      }
      if (this._hiddenBlanks) {
        this._hiddenBlanks.forEach((el) => {
          el.style.display = el.dataset.cbPrevDisplay || '';
          delete el.dataset.cbPrevDisplay;
        });
        this._hiddenBlanks = null;
      }
      if (this._slideTrack) {
        this._slideTrack.classList.add('cb-no-transition');
        this._slideTrack.style.transform = '';
        void this._slideTrack.offsetWidth;
        this._slideTrack.classList.remove('cb-no-transition');
      }
      this._slideTrack = null;
      this._slideIndex = 0;
      this._sliderActive = false;
    }
  }

  customElements.define('cinematic-fashion-banner', CinematicFashionBanner);
}
